import { ReportModules, Signatory } from '@interfaces/report-templates.interface';
import React from 'react';
import Loading from '@components/core/loading';
import PageTitle from '@components/core/page-title/page-title';
import Error from '@components/error/error';
import ManageSignatoriesGrid from '@components/shared/manage-signatories-grid';
import { Permissions } from '@contexts/user-context';
import { useAuthorization, useTranslation } from '@hooks/index';
import Constants from '@utils/constants';
import {
    ReportTemplateEndpoints,
    useDeleteItem,
    useGetSignatoriesList,
    useMutationSignatory,
} from '@apis/bff-api/report-templates';

const ManageSignatories = ({ studyId, module }: { studyId: string; module: ReportModules }) => {
    const { t } = useTranslation();
    const user = useAuthorization();
    const canEdit = !!user?.canWrite?.({
        module,
        element:
            module === Constants.Modules.RAM
                ? Constants.DataElements.RiskAssessment
                : Constants.DataElements.CentralMonitoring,
        permission: Permissions.ReadWrite,
    });
    const {
        data: signatoriesData,
        mutate: mutateSignatoriesList,
        isLoading,
        isValidating,
        error: signatoriesError,
    } = useGetSignatoriesList(studyId, module, false);
    const { trigger: putSignatory, isMutating: isMutatingPutSignatory } = useMutationSignatory();
    const { deleteItem, isLoading: isDeleteLoading } = useDeleteItem(ReportTemplateEndpoints.DELETE_SIGNATORY);

    if (isLoading || isValidating) return <Loading float />;

    if (signatoriesError) return <Error error={signatoriesError} />;

    return (
        <>
            <PageTitle text={t('cm:manageSignatories')} className="mb-10" />
            <ManageSignatoriesGrid
                items={signatoriesData as Signatory[]}
                canEdit={canEdit}
                module={module}
                onCreateUpdate={putSignatory}
                onRefetch={mutateSignatoriesList}
                onDelete={deleteItem}
                isLoading={isMutatingPutSignatory || isDeleteLoading}
            />
        </>
    );
};
export default ManageSignatories;
